import { personalities } from '../../../data/socionics/data/types'
import { Type } from '../../../calculators/socionics/objects/Type'
import { getRelation } from '../../../calculators/socionics/functions/getRelation'
import SingleBar from './BarChart2D'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ToggleView from '../../input/ToggleButton'
import { useState } from 'react';
import Bar3d from './bar3d';
import Bar3d2 from './bar3d2'
import Carousel from 'react-bootstrap/Carousel';

function BarChart(props) {
    const [radioValue, setRadioValue] = useState(false);
    function handleChange() {
        setRadioValue(!radioValue);
    }

    let opt = new Type(props.p1)
    let person
    let scores = []

    for (let j = 0; j < personalities.length; j++) {
        person = new Type(personalities[j])
        scores.push(getRelation(opt, person))
    }
    return (
        <Container>
            <Row className='justify-content-end'>
                <Col lg={2} md={4} xs={6}>
                    <ToggleView radioValue={radioValue} handleChange={handleChange} />
                </Col>
            </Row>

            {radioValue ?
                <>
                    <Carousel variant="dark">
                        <Carousel.Item>
                            <Bar3d />
                        </Carousel.Item>

                        <Carousel.Item>
                            <Bar3d2 />
                        </Carousel.Item>
                    </Carousel>
                </>
                : <SingleBar data={scores} p1={props.p1} />}
        </Container>
    )
}

export default BarChart


